import { render, staticRenderFns } from "./LoggListItem.vue?vue&type=template&id=7db2283e&scoped=true&"
import script from "./LoggListItem.vue?vue&type=script&lang=js&"
export * from "./LoggListItem.vue?vue&type=script&lang=js&"
import style0 from "./LoggListItem.vue?vue&type=style&index=0&id=7db2283e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db2283e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VRow})
